const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const NIL_UUID = '00000000-0000-0000-0000-000000000000';

export const normalizeUUIDString = (value: string | null | undefined): string | null => {
  const normalized = (value ?? '').trim().toLowerCase();
  return UUID_PATTERN.test(normalized) && normalized !== NIL_UUID ? normalized : null;
};

export const isUUIDString = (value: string | null | undefined): boolean => normalizeUUIDString(value) !== null;
